import React from 'react';
import Loadable from 'react-loadable';
import Loader from "./Loader";

const LoadingView = () => <Loader/>;

export const cloudAssessmentViewLoader = () => import('./components/cloud-assessment/CloudAssessmentView.js' /* webpackChunkName: "CloudAssessment" */);

export const NetAppInternalView = Loadable({
    loader: () => import('./components/internal/NetAppInternalView' /* webpackChunkName: "NetAppInternal" */),
    loading: LoadingView
});

export const CloudManagersView = Loadable({
    loader: () => import('./components/launch-pad/CloudManagersView.js' /* webpackChunkName: "CloudManagers" */),
    loading: LoadingView
});

export const CloudAssessmentView = Loadable({
    loader: cloudAssessmentViewLoader,
    loading: LoadingView
});

export const AccountsManagement = Loadable({
    loader: () => import('./components/accounts-management/AccountsManagement' /* webpackChunkName: "AccountsManagement" */),
    loading: LoadingView
});

export const CvsRoutes = Loadable({
    loader: () => import('./components/cvs/CvsRoutes' /* webpackChunkName: "CvsRoutes" */),
    loading: LoadingView
});

export const ApiDocContainer = Loadable({
    loader: () => import('./components/developer-hub/ApiDocContainer' /* webpackChunkName: "ApiDoc" */),
    loading: LoadingView
});

export const ComponentPlayground = Loadable({
    loader: () => import('./components/playground/ComponentPlayground' /* webpackChunkName: "ApiDoc" */),
    loading: LoadingView
});